// Types
import { GroupPermissionItem } from "containers/NewGroup/useNewGroup";

// Components
import CheckboxComponent from "components/atoms/Checkbox/Checkbox";

// Styles
import styles from "components/molecules/RoleGroup/roleGroup.module.css";

type RoleGroupProps = {
	title?: string;
	values?: Array<GroupPermissionItem>;
	readonly?: boolean;
	disabled?: boolean;
	onClick?: (v: string) => void;
	checkedRoles?: Array<string>;
};

const RoleGroup = ({ title, values, checkedRoles, readonly, disabled, onClick }: RoleGroupProps) => {
	return (
		<div className={styles?.group}>
			<p className={styles?.group_header}>{title}</p>
			{values?.map((item, idx) => {
				return (
					<div className={styles?.center} key={`${title}-${idx}`}>
						<CheckboxComponent
							id={item?.perm_code}
							name={item?.perm_short_desc}
							value={item.perm_code}
							checked={!!checkedRoles?.includes(item?.perm_code)}
							label={item.perm_short_desc}
							classes={{
								checkbox_checked: styles?.checkbox_checked,
								checkbox_input: styles?.checkbox_input,
								checkbox_label: styles?.checkbox_label
							}}
							readonly={readonly}
							isDisabled={disabled}
							onClick={onClick}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default RoleGroup;
